import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  DamageCostEvaluationDto,
  DamageCostEvaluationItemDto,
  DamageCostEvaluationItemReferenceDto,
  DamageCostEvaluationReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import DamageCostEvaluationInline from "./DamageCostEvaluationInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: DamageCostEvaluationDto | DamageCostEvaluationReferenceDto | null | undefined;
  entityId?: string | null;
  item?: DamageCostEvaluationItemDto | DamageCostEvaluationItemReferenceDto;
  itemId?: string | null;
}

export default function DamageCostEvaluationLink({
  entity,
  entityId,
  item,
  itemId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.DamageCostEvaluationRead]}
      to={ROUTE_PATH.DAMAGE_COST_EVALUATION_VIEW(entity?.id || entityId || "")}
      content={
        <DamageCostEvaluationInline
          entity={entity}
          entityId={entityId}
          item={item}
          itemId={itemId}
          {...inlineProps}
        />
      }
      {...otherProps}
    />
  );
}
